import Link from 'next/link'

import { Button } from '@/components/ui/button'
import type { ButtonBlock as TButtonBlock } from '@/payload-types'

export const ButtonBlock = ({ title, url }: TButtonBlock) => {
  if (!url) {
    return (
      <Button
        variant="vintageNav"
        size="lg"
        className="hover:text-secondary md:text-lg hover:scale-105 transition-transform duration-500"
        aria-label={title}
      >
        {title}
      </Button>
    )
  }

  return (
    <Button
      asChild
      variant="vintageNav"
      className="hover:text-secondary md:text-lg hover:scale-105 transition-all duration-500"
      size="lg"
      aria-label={title}
    >
      <Link href={url} prefetch>
        {title}
      </Link>
    </Button>
  )
}
